import styled from 'styled-components'

import List from '../List'

const UnitList = styled(List)`
  display: flex;
  flex-direction: row;
  height: 185px;
`

export default UnitList
